import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "@/store/hooks";

const WONDERPUSH_WEB_KEY =
  "51e7fb48512eb0ec2479c1e6c1e34bd5712949a552db95fcd80af6d563af8325";
const WONDERPUSH_SCRIPT_SRC =
  "https://cdn.by.wonderpush.com/sdk/1.1/wonderpush-loader.min.js";
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

declare global {
  interface Window {
    WonderPush?: unknown[];
    __shiphouseWonderPushInitialized?: boolean;
  }
}

function isStoreRoute(pathname: string) {
  const segments = pathname.split("/").filter(Boolean);
  return segments.length >= 2 && UUID_RE.test(segments[1]);
}

export function WonderPushLoader() {
  const location = useLocation();
  const { currentStoreId, hasAuthorizedStore, isAuthenticated } = useAppSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    const isFramed = window.self !== window.top;
    const isWebBuilderRoute = location.pathname.includes("/webbuilder");
    const canLoadWonderPush =
      !isFramed &&
      !isWebBuilderRoute &&
      isAuthenticated &&
      hasAuthorizedStore &&
      UUID_RE.test(currentStoreId || "") &&
      isStoreRoute(location.pathname);

    if (!canLoadWonderPush) {
      return;
    }

    if (!window.__shiphouseWonderPushInitialized) {
      window.WonderPush = window.WonderPush || [];
      window.WonderPush.push(["init", { webKey: WONDERPUSH_WEB_KEY }]);
      window.__shiphouseWonderPushInitialized = true;
    }

    if (document.querySelector("script[data-shiphouse-wonderpush='loader']")) {
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = WONDERPUSH_SCRIPT_SRC;
    script.dataset.shiphouseWonderpush = "loader";
    document.head.appendChild(script);
  }, [
    currentStoreId,
    hasAuthorizedStore,
    isAuthenticated,
    location.pathname,
  ]);

  return null;
}
